module.exports = __webpack_public_path__ + "img/youshi8.d7e0cefc.png";